import { render, staticRenderFns } from "./updateProductAttr.vue?vue&type=template&id=c15c0c8c&scoped=true&"
import script from "./updateProductAttr.vue?vue&type=script&lang=js&"
export * from "./updateProductAttr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c15c0c8c",
  null
  
)

export default component.exports